angular.module('dpw.services').factory('dpwAccessService', ['$q', 'user', 'popupUtil', 'dpwUserRoleService', 'dpwStorage', 'dpwUserPermissionService', 'developerService', function ($q, user, popupUtil, dpwUserRoleService, dpwStorage, dpwUserPermissionService, developerService) {
    var UserRole = dpwUserRoleService.UserRole;
    var storageKey = 'rcdpw-rnp-hiddenEntriesVisible';

    RCDPW.RnP = {
        showHiddenEntries: function (shouldDisplay) {
            shouldDisplay = shouldDisplay !== false;
            dpwStorage.setItem(storageKey, shouldDisplay);
        },
        hiddenEntriesVisible: function () {
            var isVisible = dpwStorage.getItem(storageKey);
            return isVisible === 'true';
        }
    };

    return {
        currentUserCan: currentUserCan,
        targetUserCan: targetUserCan,
        canManipulateApp: canManipulateApp,
        canGetStarted: canGetStarted,
        UserAction: dpwUserPermissionService.UserAction,
        invalidateCache: invalidateCache
    };

    /**
     * Verify if current user can do the organization level action.
     *
     * @param {UserAction} userAction
     * @returns {Promise<void>} Resolves when the verification is passed, otherwise rejects
     */
    function currentUserCan(userAction) {
        if (RCDPW.RnP.hiddenEntriesVisible()) {
            return $q.resolve();
        }

        var roles = dpwUserPermissionService.userPermissions[userAction];
        return isOneOf(roles);
    }

    function targetUserCan(developerId, userAction) {
        if (RCDPW.RnP.hiddenEntriesVisible()) {
            return $q.resolve();
        }

        var requiredRoles = dpwUserPermissionService.userPermissions[userAction];

        return developerService.getDeveloper(developerId)
            .then(function (developer) {
                var role = _.get(developer, 'role');
                var hasPermission = _.includes(requiredRoles, role);
                return hasPermission ? $q.resolve() : $q.reject();
            });
    }

    function canGetStarted() {
        return dpwUserRoleService.getCurrentUserRole().then(function (role) {
            return role !== UserRole.Audit ? $q.resolve() : $q.reject();
        });
    }

    /**
     * Verify if current user has the "Read & write" permission to the app.
     *
     * @param {string} appId
     * @returns {Promise<void>} Resolves when the verification is passed, otherwise rejects
     */
    function canManipulateApp(appId) {
        if (RCDPW.RnP.hiddenEntriesVisible()) {
            return $q.resolve();
        }

        return dpwUserRoleService.getCurrentUserRole().then(function (role) {
            if (role === UserRole.Administrator) {
                return $q.resolve();
            }

            if (role === UserRole.Audit) {
                return $q.reject();
            }

            if (role === UserRole.Developer) {
                return dpwUserPermissionService.canManipulateApp(appId);
            }
        });
    }

    /**
     * Judge if the current user's role is one of the required roles
     *
     * @param {Array<string>} requiredRoles
     * @returns {Promise<void>} Resolves when the user role is matched, otherwise rejects
     *
     * @example
     * dpwAccessService.isOneOf([
     *   UserRole.Administrator,
     *   UserRole.Developer
     * ]).then(function () {
     *   // Do something when current user is an Administrator or Developer
     * }).catch(function () {
     *   // Do something when current user is not an Administrator or Developer
     * });
     */
    function isOneOf(requiredRoles) {
        return dpwUserRoleService.getCurrentUserRole().then(function (role) {
            if (role === void 0) {
                return $q.defer().promise;
            }

            var isOneOf = _.includes(requiredRoles, role);
            return isOneOf ? $q.resolve() : $q.reject();
        });
    }

    function invalidateCache() {
        dpwUserPermissionService.invalidateAppAccessSettingsCache();
    }
}]);
